import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

const CountdownClockStaticRefresh = ({
  startDate,
  text,
  className,
}) => (
  <div
    className={classnames('CountdownClock', 'timestampBlue', className)}
  >
    <div>
      <span className={classnames('timestampDescription', 'timestampBlue')}>
        {text}
      </span>
      <div className={classnames('timestamp', 'timestampBlue')}>
        <img
          alt='clock disabled'
          src='/images/clock-large-blue.svg'
          className='clockIcon'
        />
        <img
          alt='clock'
          src='/images/clock-large-white.svg'
          className={classnames('clockIcon', 'disabledClockIcon')}
        />
        <span className={classnames('timestampValue', 'timestampBlue')}>
          {startDate && momentWithAustinTimezone(startDate).format('MMM D [at] hA')}
        </span>
        <span className={classnames('timestampValue', 'placeholderTimestamp')}>
          Jun 4 at 7AM
        </span>
      </div>
    </div>
  </div>
);

CountdownClockStaticRefresh.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

CountdownClockStaticRefresh.displayName = 'CountdownClockStaticRefresh';

export default CountdownClockStaticRefresh;
